import { useDispatch, useSelector } from "react-redux";
import { Button } from "../ui/button";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import {
  selectCurrentChat,
  setOpenedGroup,
} from "@/context/features/chat/chatSlice";
import {
  selectCurrentRoom,
  setActiveTab,
  setFocusOnChats,
} from "@/context/features/room/roomSlice";
import { useSidebar } from "../ui/sidebar";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { MessageCircleMore } from "lucide-react";
import { Badge } from "../ui/badge";
import { TypographyNumber } from "./numbers";

interface Props {
  toastId?: string;
  gpId?: string;
  isMain?: boolean;
}
export default function OpenChat({ toastId, gpId, isMain = false }: Props) {
  const dispatch = useDispatch();
  const { groupList } = useSelector(selectCurrentChat);
  const { unreadMessges, activeTab } = useSelector(selectCurrentRoom);
  const { toggleSidebar, setOpenMobile, isMobile, setOpen } = useSidebar();
  const { t } = useTranslation();
  if (isMain) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="relative"
            onClick={() => {
              if (activeTab === "chats") {
                toggleSidebar();
              } else {
                setOpen(true);
                if (isMobile) setOpenMobile(true);
              }
              dispatch(setActiveTab("chats"));
            }}
          >
            {unreadMessges.length > 0 && (
              <Badge
                className="absolute p-1 w-5 h-5 bg-green-500 rounded-full -top-2 -inset-s-2 pt-1.5 text-[10px] border border-background shadow"
                dir="ltr"
              >
                <TypographyNumber
                  value={
                    unreadMessges.reduce(
                      (total, message) => total + message.count,
                      0
                    ) > 99
                      ? "+99"
                      : unreadMessges.reduce(
                          (total, message) => total + message.count,
                          0
                        )
                  }
                />
              </Badge>
            )}
            <MessageCircleMore strokeWidth={1.5} />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">{t("chats")}</TooltipContent>
      </Tooltip>
    );
  }
  return (
    <div className="absolute inset-e-1 bottom-1">
      <Button
        variant={"link"}
        onClick={() => {
          const found = groupList.find((item) => item.id === gpId);
          dispatch(setFocusOnChats(true));
          if (found) {
            dispatch(setOpenedGroup(found));
          }
          toast.dismiss(toastId);
        }}
        className="ml-auto text-sm font-medium text-primary underline underline-offset-4 "
      >
        {t("view")}
      </Button>
    </div>
  );
}
